module.exports = __webpack_public_path__ + "static/media/cq_aggiorna.2243e3eb.svg";